import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuMultiSelectList } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectList';

export const SbSharedRefineMenuFilterShippingComponent = props => (
    <SbSharedRefineMenuMultiSelectList {...props} />
);

export const SbSharedRefineMenuFilterShipping = createFragmentContainer(
    SbSharedRefineMenuFilterShippingComponent,
    {
        searchBrowse: graphql`
            fragment SbSharedRefineMenuFilterShipping_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuMultiSelectList_searchBrowse
            }
        `,
    }
);
